// BottomNav — barra de navegación inferior (mobile ≤900px) de la tienda v5.
// Fuente: maquetas (5 items fijos: Home · Kits · Tienda · Carrito · Cuenta).
// Cuenta → panel cliente externo (ClienteInicio; RequireAuth redirige a login y vuelve post-login).
//
// Self-contained: <style>{BN_CSS}</style> + clases .tv5-bn-* + tokens --tv5-* propios.
// Solo visible en ≤900px (en ≥900px se oculta). Sin estado.
//
// Props:
//   active     'home'|'kits'|'tienda'|'carrito'|'cuenta'  → item activo
//   cartCount  número   → OVERRIDE del badge del carrito (default: useCart().itemsCount; solo lo pasa el QA)
import { Link } from 'react-router-dom';
import { TV5_ROUTES, TV5_EXTERNAL } from './routes';
import { useCart } from '../../lib/CartContext';

const BN_CSS = `
.tv5-bn {
  --tv5-teal:#00A8B5; --tv5-navy:#1A3461; --tv5-dim:rgba(248,246,241,0.45); --tv5-border:rgba(255,255,255,0.08);
  position:fixed; bottom:0; left:0; right:0; z-index:90; background:rgba(10,20,36,0.95);
  backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px);
  border-top:1px solid var(--tv5-border); padding:8px 0 calc(8px + env(safe-area-inset-bottom,0px));
  display:grid; grid-template-columns:repeat(5,1fr); gap:4px;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-bn-item {
  background:transparent; border:0; color:var(--tv5-dim); padding:6px 8px;
  display:flex; flex-direction:column; align-items:center; gap:3px; min-height:44px; justify-content:center;
  font-size:11px; font-weight:600; cursor:pointer; text-decoration:none; position:relative;
}
.tv5-bn-item .tv5-bn-icon { font-size:20px; }
.tv5-bn-item.active { color:var(--tv5-teal); }
.tv5-bn-badge {
  position:absolute; top:0; right:calc(50% - 20px); background:var(--tv5-teal); color:var(--tv5-navy);
  font-size:9px; font-weight:900; padding:1px 5px; border-radius:999px; min-width:14px; text-align:center;
}
@media (min-width:900px){ .tv5-bn { display:none; } }
`;

export function BottomNav({ active, cartCount }) {
  const { itemsCount } = useCart();
  const badge = cartCount ?? itemsCount; // prop pisa (QA); default = carrito real
  const cls = (key) => 'tv5-bn-item' + (active === key ? ' active' : '');
  return (
    <nav className="tv5-bn">
      <style>{BN_CSS}</style>
      <Link to={TV5_ROUTES.home} className={cls('home')}>
        <span className="tv5-bn-icon">🏠</span><span>Home</span>
      </Link>
      <Link to={TV5_ROUTES.kits} className={cls('kits')}>
        <span className="tv5-bn-icon">🎁</span><span>Kits</span>
      </Link>
      <Link to={TV5_ROUTES.tienda} className={cls('tienda')}>
        <span className="tv5-bn-icon">🛍️</span><span>Tienda</span>
      </Link>
      <Link to={TV5_ROUTES.checkout} className={cls('carrito')}>
        <span className="tv5-bn-icon">🛒</span><span>Carrito</span>
        {badge > 0 && <span className="tv5-bn-badge">{badge}</span>}
      </Link>
      <a href={TV5_EXTERNAL.cuenta} className={cls('cuenta')}>
        <span className="tv5-bn-icon">👤</span><span>Cuenta</span>
      </a>
    </nav>
  );
}
